module.exports = __webpack_public_path__ + "static/media/essential-oil-1731518_640.9ba4ff14.jpg";